<div class="d-flex align-items-center justify-content-between px-4 pt-4 px-md-8 pt-md-8">
  <h1 class="semi-bold">Passcode protected</h1>
</div>

<p class="mt-2 mx-4 mx-md-8">Enter the last 4 digits of the phone number linked to your account</p>

<form [formGroup]="form" class="mt-6 mx-4 mx-md-8 mb-8">
  <ds-otp-input
    formControlName="code"
    [length]="4"
    [autoFocus]="true"
    [error]="passcodeError || undefined"
    [state]="otpState"
    inputId="passcode"
    (completed)="onCompleted($event)"
  />

  <p *ngIf="passcodeError" class="d-none" data-id="error">
    {{ passcodeError }}
  </p>
</form>
